import * as React from 'react';

// Modules
import { DI } from 'modules';

const DownloadSliderContacts = ({ common = {} }) => {
  const { strings = {} } = common;

  // Root className
  const rootCln = 'side-buy-contacts';

  // Strings
  const reachedPrefix = 'page.video.slider.ruptly_pass.reached';

  return (
    <div className={rootCln}>
      <div className={`${rootCln}__text`}>
        {strings['page.video.slider.enterprise.additions.reached.has_refill_5']}
      </div>

      <div className={`${rootCln}__text`}>
        <a
          className={`${rootCln}__link ${rootCln}__link--phone`}
          href={`tel:${strings[`${reachedPrefix}.phone`].replace(' ', '')}}`}
        >
          {strings[`${reachedPrefix}.phone`]}
        </a>
      </div>

      <div className={`${rootCln}__text`}>
        <a
          className={`${rootCln}__link ${rootCln}__link--email`}
          href={`mailto:${strings[`${reachedPrefix}.email`]}`}
          target="_top"
        >
          {strings[`${reachedPrefix}.email`]}
        </a>
      </div>
    </div>
  );
};

export default DI(['common'])(DownloadSliderContacts);
